export default "__VITE_ASSET__1eec4581__"